import React from 'react';

export const close_icon = (
	<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.83477 0.167478C7.61146 -0.0558259 7.24186 -0.0558259 7.01855 0.167478L4.00112 3.18491L0.98369 0.167478C0.760387 -0.0558259 0.390781 -0.0558259 0.167478 0.167478C-0.0558259 0.390781 -0.0558259 0.760387 0.167478 0.98369L3.18491 4.00112L0.167478 7.01855C-0.0558259 7.24186 -0.0558259 7.61146 0.167478 7.83477C0.282979 7.95027 0.429282 8.00417 0.575584 8.00417C0.721886 8.00417 0.868189 7.95027 0.98369 7.83477L4.00112 4.81734L7.01855 7.83477C7.13406 7.95027 7.28036 8.00417 7.42666 8.00417C7.57296 8.00417 7.71926 7.95027 7.83477 7.83477C8.05807 7.61146 8.05807 7.24186 7.83477 7.01855L4.81734 4.00112L7.83477 0.98369C8.05807 0.760387 8.05807 0.390781 7.83477 0.167478Z"
			fill="#B3BCC3"
		/>
	</svg>
);

export const funnel_icon = (
	<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.8345 1.15331C15.8345 1.79021 15.3183 2.30662 14.6812 2.30662H1.15331C0.516414 2.30662 0 1.7904 0 1.15331C0 0.516413 0.516222 0 1.15331 0H14.6814C15.3183 0 15.8345 0.516413 15.8345 1.15331Z"
			fill="#6E7881"
		/>
		<path
			d="M13.9196 6.00097C13.9196 6.63786 13.4033 7.15428 12.7663 7.15428H3.06933C2.43243 7.15428 1.91602 6.63806 1.91602 6.00097C1.91602 5.36407 2.43224 4.84766 3.06933 4.84766H12.7664C13.4033 4.84766 13.9196 5.36407 13.9196 6.00097Z"
			fill="#6E7881"
		/>
		<path
			d="M11.0462 10.8467C11.0462 11.4836 10.5299 12 9.89286 12H5.94237C5.30548 12 4.78906 11.4838 4.78906 10.8467C4.78906 10.2098 5.30528 9.69336 5.94237 9.69336H9.89305C10.5299 9.69336 11.0462 10.2098 11.0462 10.8467Z"
			fill="#6E7881"
		/>
	</svg>
);

export const map_marker_icon = (
	<svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6 0C2.69119 0 0 2.69118 0 5.99999C0 7.17343 0.289386 8.01523 0.898717 8.91595L5.65734 15.9504C5.69526 16.0064 5.74632 16.0523 5.80605 16.084C5.86579 16.1156 5.93238 16.1322 6 16.1322C6.06762 16.1322 6.13422 16.1156 6.19395 16.084C6.25369 16.0523 6.30475 16.0064 6.34266 15.9504L11.1013 8.91595C11.7106 8.01521 12 7.17343 12 5.99999C12 2.69118 9.30882 0 6 0ZM6 0.827585C8.86155 0.827585 11.1724 3.13845 11.1724 5.99999C11.1724 7.05041 10.9659 7.64385 10.416 8.45689L6 14.987L1.58404 8.45689C1.03409 7.64387 0.827586 7.05041 0.827586 5.99999C0.827586 3.13845 3.13846 0.827585 6 0.827585ZM6 2.89655C4.40518 2.89655 3.10345 4.19828 3.10345 5.7931C3.10345 7.3879 4.40518 8.68965 6 8.68965C7.59482 8.68965 8.89655 7.3879 8.89655 5.7931C8.89655 4.19828 7.59482 2.89655 6 2.89655ZM6 3.72413C7.14755 3.72413 8.06897 4.64555 8.06897 5.7931C8.06897 6.94063 7.14755 7.86206 6 7.86206C4.85245 7.86206 3.93104 6.94063 3.93104 5.7931C3.93104 4.64555 4.85245 3.72413 6 3.72413Z"
			fill="#6E7881"
		/>
	</svg>
);

export const chevron_right = (
	<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M1.06503 17.9006C0.801131 17.9006 0.518379 17.8064 0.311027 17.599C-0.103676 17.1843 -0.103676 16.5245 0.311027 16.1098L7.45523 8.94679L0.311027 1.80259C-0.103676 1.38788 -0.103676 0.728128 0.311027 0.313425C0.72573 -0.101278 1.38549 -0.101278 1.80019 0.294575L9.6984 8.19278C9.90575 8.40014 10 8.66404 10 8.94679C10 9.22954 9.8869 9.49344 9.6984 9.7008L1.80019 17.599C1.59284 17.8064 1.32894 17.9006 1.06503 17.9006Z"
			fill="#6E7881"
		/>
	</svg>
);

export const chevron_down = (
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" fill="none" viewBox="0 0 10 6">
		<path stroke="#383F44" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M1 1l4 4 4-4" />
	</svg>
);

export const chevron_right_small = (
	<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" fill="none" viewBox="0 0 6 10">
		<path stroke="#383F44" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" d="M1 9l4-4-4-4"></path>
	</svg>
);

export const chevron_left_small = (
	<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" fill="none" viewBox="0 0 6 10">
		<path stroke="#383F44" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" d="M5 9L1 5l4-4"></path>
	</svg>
);
